import { __DEV__ } from './assertion.esm.js';

/* eslint-disable no-console */
function warn(options) {
  if (options.condition && __DEV__) {
    console.warn(options.message);
  }
}

export { warn };
//# sourceMappingURL=logger.esm.js.map
